/**
 * en-GB messages added by Phase 1 task K2 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const k2EnGB = {
    'kiosk.common.back': 'Back',
    'kiosk.common.next': 'Next',
    'kiosk.common.continue': 'Continue',
    'kiosk.common.cancel': 'Cancel',
    'kiosk.common.yes': 'Yes',
    'kiosk.common.no': 'No',
    'kiosk.welcome.tap': 'Tap here to sign in or out',
    'kiosk.welcome.offline': 'Offline: sign-ins are saved and sent later',
    'kiosk.home.title': 'What would you like to do?',
    'kiosk.home.signIn': 'Sign in',
    'kiosk.home.signOut': 'Sign out',
    'kiosk.home.scan': 'Scan my badge',
    'kiosk.groups.titleIn': 'Who are you signing in as?',
    'kiosk.groups.titleOut': 'Who are you signing out as?',
    'kiosk.groups.hint': 'Choose the one that fits you best.',
    'kiosk.groups.repeat': 'Regular members',
    'kiosk.pin.hint': 'Enter your 4-digit PIN.',
    'kiosk.pin.entered': '{count} of 4 digits entered',
    'kiosk.pin.wrong': 'That PIN is not right. Please try again.',
    'kiosk.pin.locked': 'Too many wrong PINs. PIN entry is locked for a few minutes. Please ask someone to help.',
    'kiosk.pin.clear': 'Clear',
    'kiosk.pin.back': 'Delete the last digit',
    'kiosk.identify.title': 'Find your name',
    'kiosk.identify.placeholder': 'Start typing your name',
    'kiosk.identify.none': 'No one found with that name.',
    'kiosk.identify.addSelf': 'I am not on the list',
    'kiosk.addSelf.title': 'Add yourself',
    'kiosk.name.title': 'What is your name?',
    'kiosk.name.label': 'Your name',
    'kiosk.name.fullNameHint': 'Please give your first name and surname.',
    'kiosk.already.message': 'You are already signed in. Would you like to sign out instead?',
    'kiosk.already.signOut': 'Sign me out',
    'kiosk.questions.titleIn': 'A few quick questions',
    'kiosk.questions.titleOut': 'Before you go',
    'kiosk.questions.datePlaceholder': 'YYYY-MM-DD',
    'kiosk.questions.acknowledge': 'I understand',
    'kiosk.questions.hostSearch': 'Type the name of the person you are visiting',
    'kiosk.questions.changeHost': 'Change',
    'kiosk.notices.progress': 'Notice {n} of {total}',
    'kiosk.notices.accept': 'I have read this and accept',
    'kiosk.notices.sign': 'Sign',
    'kiosk.notices.signHere': 'Please sign with your finger.',
    'kiosk.signature.pad': 'Signature box',
    'kiosk.signature.clear': 'Clear signature',
    'kiosk.signature.captured': 'Signature saved',
    'kiosk.photo.title': 'Photo',
    'kiosk.photo.hint': 'Look at the camera and tap the button.',
    'kiosk.photo.take': 'Take my photo',
    'kiosk.photo.getReady': 'Get ready…',
    'kiosk.photo.retake': 'Take it again',
    'kiosk.photo.use': 'Use this photo',
    'kiosk.photo.skip': 'Skip the photo',
    'kiosk.photo.failed': 'The photo did not work. Please try again.',
    'kiosk.photo.noCamera': 'The camera is not available. You can carry on without a photo.',
    'kiosk.photo.privacy': 'Your photo is only used for your badge and the visitor record.',
    'kiosk.badge.title': 'Your badge',
    'kiosk.badge.ask': 'Would you like a badge?',
    'kiosk.badge.yes': 'Print my badge',
    'kiosk.badge.no': 'No badge, thanks',
    'kiosk.badge.printing': 'Printing your badge…',
    'kiosk.badge.done': 'Please take your badge',
    'kiosk.badge.failed': 'Sorry, the badge did not print. You are signed in. Please ask at reception for a badge.',
    'kiosk.signout.title': 'Find your name to sign out',
    'kiosk.signout.search': 'Search by name',
    'kiosk.signout.hiddenHint': 'For privacy, names are not listed. Type your name or scan your badge.',
    'kiosk.signout.empty': 'No one is signed in.',
    'kiosk.signout.noMatch': 'No one found. Try again, or scan your badge.',
    'kiosk.signout.unnamed': 'Visitor',
    'kiosk.scan.title': 'Scan your badge',
    'kiosk.scan.hint': 'Hold the QR code on your badge in front of the camera.',
    'kiosk.scan.allow': 'Allow the camera',
    'kiosk.scan.noCamera': 'The camera is not available. Please choose your name from the list instead.',
    'kiosk.scan.notBadge': 'That is not a CloudSign badge. Please try again.',
    'kiosk.scan.notSignedIn': 'That badge is not signed in here. Please choose your name from the list.',
    'kiosk.finish.inTitle': 'Thank you, {name}',
    'kiosk.finish.inMessage': 'You are signed in.',
    'kiosk.finish.outTitle': 'Goodbye, {name}',
    'kiosk.finish.outMessage': 'You are signed out. Safe journey.',
    'kiosk.finish.tap': 'Tap to finish',
    'kiosk.update.title': 'This kiosk needs an update',
    'kiosk.update.message': 'This kiosk needs an update before it can sign you in here. Please ask at reception.',
    'kiosk.update.short': 'Needs an update',
    'kiosk.error.required': 'Please answer this question.',
    'kiosk.error.mustAcknowledge': 'Please tick to confirm.',
    'kiosk.error.nameRequired': 'Please type your name.',
    'kiosk.error.fullName': 'Please give your first name and surname.',
    'kiosk.error.tooLong': 'That answer is too long.',
    'kiosk.error.number': 'Please enter a number.',
    'kiosk.error.wholeNumber': 'Please enter a whole number.',
    'kiosk.error.range': 'That number is outside the allowed range.',
    'kiosk.error.email': 'Please enter a valid email address.',
    'kiosk.error.phone': 'Please enter a valid phone number.',
    'kiosk.error.date': 'Please enter a date like 2026-12-31.',
    'kiosk.error.answerNotAllowed': 'That answer means you cannot sign in here. Please speak to reception.',
};
//# sourceMappingURL=k2.js.map